import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-225f570f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = {
  key: 0,
  class: "description"
}
const _hoisted_3 = {
  key: 1,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_4 = ["href"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 2,
  class: "description"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Zum Projekt: ")
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 3,
  class: "description"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Weitere Informationen: ")
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 4,
  class: "description"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Weitere Informationen: ")
const _hoisted_14 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("p", _hoisted_1, null, 512), [
      [_directive_dompurify_html, _ctx.entry.title]
    ]),
    (_ctx.descriptionDisplay)
      ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_2, null, 512)), [
          [_directive_dompurify_html, _ctx.entry.description]
        ])
      : _createCommentVNode("", true),
    (_ctx.entry.file)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", null, [
            _createElementVNode("a", {
              href: _ctx.entry.file?.url,
              target: "_blank",
              style: _normalizeStyle(_ctx.fullScreenImage ? 'max-width: 90%;' : 'width: 50%;')
            }, [
              _createElementVNode("img", {
                style: {"max-width":"100%","max-height":"300px"},
                src: _ctx.entry.file?.url,
                alt: ""
              }, null, 8, _hoisted_5)
            ], 12, _hoisted_4)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.linkedProjectDisplay)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("a", {
            href: _ctx.entry.linked_project.links.external_show_uri.href
          }, null, 8, _hoisted_8), [
            [_directive_dompurify_html, _ctx.entry.linked_project.name]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.linkedPageDisplay)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
          _hoisted_10,
          _withDirectives(_createElementVNode("a", {
            href: _ctx.entry.linked_page.links.external_show_uri.href
          }, null, 8, _hoisted_11), [
            [_directive_dompurify_html, _ctx.entry.linked_page.name]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.uriDisplay)
      ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("a", {
            target: "_blank",
            href: _ctx.entry.uri
          }, null, 8, _hoisted_14), [
            [_directive_dompurify_html, _ctx.uriDisplay]
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}